import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const CasinoTaxAdvantage = () => {
  const { t, currentLanguage } = useLanguage();

  // Only show this component for German and English
  if (currentLanguage !== 'de' && currentLanguage !== 'en') {
    return null;
  }

  return (
    <section className="py-16 bg-gradient-to-br from-primary-50 to-primary-100">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <div className="text-center mb-8">
              <div className="inline-block bg-primary-500 text-white text-2xl font-bold px-6 py-3 rounded-full mb-4">
                {t('casino-tax-advantage-badge')}
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-neutral-800 mb-4">
                {t('casino-tax-advantage-title')}
              </h2>
              <p className="text-lg text-neutral-600 max-w-2xl mx-auto">
                {t('casino-tax-advantage-subtitle')}
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-6 mb-8">
              <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-6 border-l-4 border-green-500">
                <div className="flex items-center mb-4">
                  <div className="bg-green-500 text-white rounded-full p-3 mr-4">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-green-700">
                    {t('casino-tax-advantage-80-title')}
                  </h3>
                </div>
                <p className="text-neutral-700">
                  {t('casino-tax-advantage-80-desc')}
                </p>
              </div>

              <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 border-l-4 border-blue-500">
                <div className="flex items-center mb-4">
                  <div className="bg-blue-500 text-white rounded-full p-3 mr-4">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-blue-700">
                    {t('casino-tax-advantage-benefits-title')}
                  </h3>
                </div>
                <p className="text-neutral-700">
                  {t('casino-tax-advantage-benefits-desc')}
                </p>
              </div>
            </div>

            <div className="bg-primary-50 rounded-xl p-6 border-2 border-primary-200">
              <h3 className="text-xl font-bold text-primary-800 mb-4">
                {t('casino-tax-advantage-how-title')}
              </h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <span className="text-primary-500 mr-3 font-bold">1.</span>
                  <span className="text-neutral-700">{t('casino-tax-advantage-step-1')}</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-500 mr-3 font-bold">2.</span>
                  <span className="text-neutral-700">{t('casino-tax-advantage-step-2')}</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-500 mr-3 font-bold">3.</span>
                  <span className="text-neutral-700">{t('casino-tax-advantage-step-3')}</span>
                </li>
              </ul>
            </div>

            <div className="mt-8 text-center">
              <button
                onClick={() => {
                  const element = document.getElementById('certificate-form');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="btn-primary px-8 py-4 text-lg font-semibold"
              >
                {t('casino-tax-advantage-cta')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CasinoTaxAdvantage;



